import React, { useState } from "react";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";

const Nav: React.FC = () => {
  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);
  return (
    <header className="public_header">
      <nav className="navbar navbar-fixed-top nav_dark landing_nav px-4 py-3">
        <Link to="/" className="navbar-brand">
          <img
            src="https://flangoo-cdn.s3.us-east-2.amazonaws.com/Flangoo_logo_white120.png"
            alt="Flangoo - Homepage"
          />
        </Link>
        <div>
          <div className="btn-group login_ctas">
            <Link to="/student_signin" className="btn btn-primary">
              {" "}
              Student Sign-In{" "}
            </Link>
            <button
              type="button"
              onMouseEnter={isMobile ? undefined : toggle}
              onClick={toggle}
              className="btn btn-primary dropdown-toggle dropdown-toggle-split no_focus"
              data-toggle="dropdown"
              aria-expanded={show ? "true" : "false"}
              aria-controls="signin-dropdown-menu"
              aria-label="More sign-in options"
            >
              <span className="sr-only">More Options</span>
            </button>
            <ul
              id="signin-dropdown-menu"
              onMouseLeave={isMobile ? undefined : toggle}
              className={`dropdown-menu dropdown-menu-right bg-light ${
                show ? "show" : ""
              } `}
              role="menu"
            >
              <li role="none">
                <Link to="/signin" className="dropdown-item" onClick={toggle} role="menuitem">
                  {" "}
                  Teacher Sign-In
                </Link>
              </li>
              <li role="separator" className="dropdown-divider"></li>
              <li role="none">
                <Link className="dropdown-item" to="/signup" onClick={toggle} role="menuitem">
                  Create Teacher Account
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Nav;
